import React from 'react'
import { Action } from 'redux'
import { ModalActions } from '../../reducers/modals/actionNames'

const requestOpenModal = (
  id: string,
  element: React.ReactElement,
  uid: string | undefined = undefined,
): IRequestOpenModal => ({
  element,
  id,
  type: ModalActions.RequestOpenModal,
  uid,
})

export interface IRequestOpenModal
  extends Action<ModalActions.RequestOpenModal> {
  id: string
  element: React.ReactElement
  uid?: string | undefined
}

export default requestOpenModal
